import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/data-entities/data-entities/$projId/explore')({
  beforeLoad: () => getTitleContextSlice('Explore'),
  staticData: {
    owner: CodeOwner.DataFabric,
  },
});
